module.exports = __webpack_public_path__ + "static/team_member.5e4fc102.png";